import { render } from "./StoreShopper.vue?vue&type=template&id=9c731064&scoped=true"
import script from "./StoreShopper.vue?vue&type=script&lang=js"
export * from "./StoreShopper.vue?vue&type=script&lang=js"

import "./StoreShopper.vue?vue&type=style&index=0&id=9c731064&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c731064"]])

export default __exports__